import React from 'react';
import { CheckCircle2Icon, PartyPopperIcon, RefreshCwIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
import { PRICE, PRICE_TOTAL_VALUE } from '../config';
const includes = ['Sistema Corrige Evaluaciones en 30 minutos (6 Tomos Premium)', '6 Bonos Exclusivos', 'Acceso inmediato', 'Actualizaciones futuras'];
export function Offer() {
  return <Section id="oferta" className="bg-white" data-id="element-136">
      <Reveal className="text-center" data-id="element-137">
        <span className="mx-auto mb-3 inline-flex items-center gap-1.5 rounded-full bg-brand-orange/15 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-brand-orange" data-id="element-138">
          <PartyPopperIcon className="h-4 w-4" data-id="element-139" />
          Oferta Especial de Lanzamiento
        </span>
      </Reveal>

      <Reveal className="mx-auto mt-2 max-w-md overflow-hidden rounded-3xl bg-brand-purpleDark shadow-2xl" data-id="element-140">
        <div className="p-6 sm:p-8" data-id="element-141">
          <h2 className="text-center font-display text-2xl font-extrabold text-white" data-id="element-142">
            Esto es todo lo que recibirás hoy
          </h2>

          <ul className="mt-5 space-y-2.5" data-id="element-143">
            {includes.map(t => <li key={t} className="flex items-start gap-2.5 text-left" data-id="element-144">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-teal" data-id="element-145" />
                <span className="text-sm font-semibold text-white/90" data-id="element-146">{t}</span>
              </li>)}
          </ul>

          <div className="mt-6 rounded-2xl bg-white/10 p-5 text-center" data-id="element-147">
            <p className="text-sm font-semibold text-white/70" data-id="element-148">
              Valor total estimado:{' '}
              <span className="line-through" data-id="element-149">{PRICE_TOTAL_VALUE}</span>
            </p>
            <p className="mt-2 text-sm font-bold uppercase tracking-wide text-brand-teal" data-id="element-150">
              Hoy puedes obtenerlo por solo
            </p>
            <p className="font-display text-5xl font-extrabold text-white sm:text-6xl" data-id="element-151">
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-white/60" data-id="element-152">
              Pago único · Descarga inmediata · Acceso de por vida
            </p>
          </div>

          <div className="mt-6" data-id="element-153">
            <CtaButton data-id="element-154">Quiero corregir en 30 minutos</CtaButton>
          </div>

          <div className="mt-5 rounded-xl bg-white/5 p-4" data-id="element-155">
            <CountdownTimer data-id="element-156" />
          </div>

          <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-xs font-semibold text-white/70" data-id="element-157">
            <RefreshCwIcon className="h-3.5 w-3.5 text-brand-teal" data-id="element-158" />
            El cambio de moneda es automático: pagas el equivalente en la moneda
            de tu país.
          </p>
        </div>
      </Reveal>

      <Reveal className="mt-6" data-id="element-159">
        <ScarcityBar data-id="element-160" />
      </Reveal>
    </Section>;
}